module.exports = __webpack_public_path__ + "static/media/transport.10f47880.png";